import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";

export const styles = ({ spacing }: Theme) => createStyles({
    title: {
        textTransform: "uppercase",
        marginBottom: spacing.unit
    }
});


// WEBPACK FOOTER //
// ./src/components/Plus/Plus.style.tsx